import { Link } from "@tanstack/react-router";
import { TornEdge } from "@/components/TornEdge";
import { PaperTexture } from "@/components/PaperTexture";

export function AboutSection() {
  return (
    <section className="bg-[#F5EFE2] py-16 md:py-24">
      <div className="relative overflow-hidden bg-[#8B6F47]">
        <TornEdge position="top" color="#F5EFE2" />
        <TornEdge position="bottom" color="#F5EFE2" />
        <PaperTexture />

        <div className="relative grid grid-cols-1 lg:grid-cols-2">
          {/* Photo — full-bleed on desktop, framed/matted below lg */}
          <div className="px-6 pt-12 pb-0 lg:relative lg:h-auto lg:p-0">
            <img
              src="https://cdn.shopify.com/s/files/1/0808/1332/6620/files/72073502393__7E5DC768-9C66-41E8-9022-BEAB56C8856E.jpg?v=1699984696"
              alt="Texas ranch at golden hour"
              width={1200}
              height={1500}
              loading="lazy"
              className="h-[300px] w-full rounded-lg object-cover shadow-[0_18px_36px_-12px_rgba(65,32,25,0.45)] lg:h-full lg:rounded-none lg:shadow-none"
            />
          </div>

          {/* Copy panel */}
          <div className="relative flex flex-col justify-center px-8 py-14 sm:px-10 lg:min-h-[620px] lg:px-16 lg:py-20 xl:px-20">
            <div className="relative">
              <span className="font-ui text-xs font-bold uppercase tracking-[0.3em] text-[#F5EFE2]">
                Our Story
              </span>
              <h2 className="mt-4 font-heading text-[36px] font-black uppercase leading-[1.05] tracking-tight text-[#F5EFE2] sm:text-5xl lg:text-[60px]">
                Rooted in Heritage.
                <br />
                Built for the Long Haul.
              </h2>
              <div className="mt-6 h-px w-16 bg-[#F5EFE2]/60" />
              <p className="mt-6 max-w-xl font-body text-[17px] leading-relaxed text-[#F5EFE2]/90 md:text-[18px]">
                From Texas pastures to the open road, Coyote Creek Hat Co. is more
                than a brand — it's a way of life. Discover the people, the values,
                and the craftsmanship behind every stitch.
              </p>
              <Link
                to="/heritage"
                className="group mt-10 inline-flex items-center gap-2 border-b-2 border-[#F5EFE2] pb-1 font-ui text-sm font-extrabold uppercase tracking-[0.2em] text-[#F5EFE2] transition-colors duration-200 hover:border-[#FA5021] hover:text-[#FA5021]"
              >
                Discover Our Heritage
                <span
                  aria-hidden="true"
                  className="transition-transform duration-200 group-hover:translate-x-1"
                >
                  →
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
